var n = function (e) {
  return e.confirmed = "confirmed", e.pending = "pending", e;
}(n || {});

export { n as ConfirmationStatus };